// @flow

import styled from "styled-components";

import Button from "../../_atom/Buttons/default";
import { fontMedium, fontNormal, fontBold } from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";

export const RaceSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 12px 6px 12px 12px;
  background-color: ${buildColor("white", "100")};

  & > * {
    flex-shrink: 0;
  }
`;

export const RaceInfo = styled.div`
  flex: 1 1 auto;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;

  & li {
    font-size: 14px;
  }
`;

export const TrackRace = styled.h3`
  display: flex;
  text-align: left;
  font-family: ${fontBold};
  font-size: 16px;
  line-height: 22px;
  color: ${buildColor("grey", "900")};
`;

export const TrackDate = styled.time`
  font-family: ${fontNormal};
  display: flex;
  text-align: left;
  font-size: 14px;
  color: ${buildColor("grey", "600")};
  line-height: 18px;
`;

export const RaceDataList = styled.ul`
  list-style: none;
  text-align: left;
`;

export const RaceArrowLink = styled(Button)`
  background: ${buildColor("white", "0")};
  width: 40px;

  &:active {
    background-color: ${buildColor("white", "50")};
  }
`;

export const RaceArrowContent = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  flex-direction: column;
`;

export const RaceArrowNavigation = styled.div`
  display: flex;
  flex: 0 0 72px;
  flex-direction: row;
  align-items: stretch;
  margin-left: 8px;
`;

export const NavigationTip = styled.span`
  font-family: ${fontMedium};
  font-size: 12px;
  color: ${({ hasCallback }) =>
    hasCallback ? buildColor("black", "100") : buildColor("grey", "600")};
`;
